import { i18n } from '@/i18n';
import { FormKitGlobalRule } from '@/types/interfaces/ValidationRule.interface';

/** Only for global use. @see https://formkit.com/essentials/validation#adding-a-rule-globally */
export const DecimalPlacesFormKitRule: FormKitGlobalRule = {
  name: 'decimal_places',
  rule: (node, value: number = 2): boolean => {
    const inputValue = String(node.value);
    const decimalPlaces = inputValue.split('.')[1]?.length || 0;
    return decimalPlaces <= value;
  },
  message: ({ name, args }) => i18n.global.t('validation.decimal_places', { name, value: args[0] }),
};
